// For links that are set to open in a new tab
// Adds visually hidden span for screen readers to announce that the link opens in a new tab
/**
 *
 *  <a href="https://google.com" target="_blank">Click Here</a>
 *
 */
// include in the global index.ts to implement

export const setupHiddenLinkText = function (): void {
  const links: NodeListOf<HTMLAnchorElement> =
    document.querySelectorAll('a[target="_blank"]');
  links.forEach((link: HTMLAnchorElement) => {
    link.insertAdjacentHTML(
      "beforeend",
      "<span class='sr-only'>opens in a new tab</span>"
    );
  });
};
